import React from 'react'
import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import {
    ProgramTagsQuery,
    ProgramTagsQueryVariables,
    ShowContainersQuery, ShowContainersQueryVariables, ShowType
} from 'generated/graphql'
import { useEventSlug, useQuery } from 'hooks'
import SelectField, { convertGroupedTags } from 'features/forms/components/SelectField'
import { sponsorSelector } from 'features/events/eventSlice'
import { _ } from 'utils'
import TextField from '../../forms/components/TextField'
import DateField from '../../forms/components/DateField'
import Editor from '../../forms/components/Editor'
import FileUpload, { PDF_PPT_ONLY } from '../../forms/components/FileUpload'
import ColorField from '../../forms/components/ColorField'
import TimeField from '../../forms/components/TimeField'
import { programTagsQuery, showContainersQuery } from '../graphql/query'

const GeneralSetting = () => {
    const eventSlug = useEventSlug()
    const sponsors = useSelector(sponsorSelector)
    const formContext = useFormikContext()
    const values = formContext.values as ShowType

    const { data: containerData } = useQuery<ShowContainersQuery, ShowContainersQueryVariables>(
        showContainersQuery,
        { eventSlug }
    )

    const { data: tagsData } = useQuery<ProgramTagsQuery, ProgramTagsQueryVariables>(programTagsQuery, {
        eventId: eventSlug,
    })

    return (
        <>
            <TextField name="name" isRequired label={_('show.form.name')} />
            <SelectField
                name="containerId"
                label={_('show.form.show_container')}
                options={containerData?.showContainers || []}
                optionLabel="name"
                optionValue="id"
                lg={1 / 2}
            />
            <SelectField
                name="tags"
                label={_('show.form.tags')}
                isMulti
                options={convertGroupedTags(tagsData?.event?.programTags)}
                optionLabel="text"
                optionValue="id"
                lg={1 / 2}
            />
            <TextField
                name="externalId"
                label={_('show.form.external_id')}
                helperText={_('show.form.external_id_helper_text')}
                showInfoIcon
                lg={1/2}
            />
            <SelectField
                name="sponsorId"
                label={_('show.form.sponsor')}
                options={sponsors || []}
                optionLabel="name"
                optionValue="id"
                lg={1/2}
            />
            <DateField
                name="startDate"
                isRequired
                dateFormat="MMM do, yyyy"
                label={_('show.form.start_date')}
                lg={1/2}
                shouldCloseOnSelect={false}
            />
            <TimeField
                name="startDate"
                isRequired
                label={_('show.form.start_time')}
                lg={1/2}
            />
            <DateField
                name="endDate"
                isRequired
                dateFormat="MMM do, yyyy"
                label={_('show.form.end_date')}
                lg={1/2}
                shouldCloseOnSelect={false}
            />
            <TimeField
                name="endDate"
                isRequired
                label={_('show.form.end_time')}
                lg={1/2}
            />
            <ColorField name="color" label={_('show.form.color')} isRequired lg={1/2} />
            <Editor name="description" label={_('show.form.description')} />
            <FileUpload
                name="attachment"
                dependField="attachmentName"
                label={_('show.form.attachment')}
                placeholder={_('show.form.attachment.placeholder')}
                accept={PDF_PPT_ONLY}
                maxSize={8}
                lg={1/2}
            />
            <TextField
                name="attachmentName"
                label={_('show.form.attachmentName')}
                placeholder={_('show.form.attachmentName.placeholder')}
                lg={1/2}
                isDisabled={!values?.attachment}
            />
        </>
    )
}

export default GeneralSetting
